import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { finalize, forkJoin, tap } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { ApiService } from 'src/services/apiService';
import { AuthService } from 'src/services/auth.service';
import { SweetAlertService } from 'src/services/sweetAlertService';

@Component({
  selector: 'app-investment-profile',
  templateUrl: './investment-profile.component.html',
  styleUrls: ['./investment-profile.component.css']
})
export class InvestmentProfileComponent {


  userInfo:any;
  personalInfo:any;
  isLoading:boolean=true;
  nationality:string|undefined;
  loginBy:string|undefined;

  showChageEmailDialog=false;
  showChagePhoneDialog=false;
  showOtpDialog=false;

  email:string|undefined;
  phone:any|undefined;
  token:string|undefined;


  otp:number|undefined;

  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  phoneNumber:any|undefined;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.Jordan];
  mainPath = "" // قراءة القيمة من environment

  constructor(private apiService:ApiService,private authService: AuthService,
    private sweetAlertservice:SweetAlertService,
    private cookiesService:CookieService,

  ) {
    this.mainPath= environment.MainPath;

    ;

    this.loginBy=this.cookiesService.get('lgoinBy');

    forkJoin([this.getUserInfo(),this.getUserNationality()])
    .pipe(finalize(() => this.isLoading = false))
    .subscribe();

  }



  getUserInfo(){
    var request= this.apiService.get('Consumer/GetInfo');

    return request.pipe(tap(response=>{
      this.userInfo=response.data;
    }));
  }

  getUserNationality(){
    
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Accept-Language': 'ar-JO',
      
      'Authorization': this.authService.getToken()!=undefined ? `Bearer ${this.authService.getToken()}` :'',
    });

    var request= this.apiService.get(`Moin/GetPersonalInfo`, `${environment.govnet}`, headers);
    return request.pipe(
      tap(response => {
        this.nationality=response.data.nationalty;
        this.personalInfo=response.data;
      }
    ));
  }


  get getUserName(): string {
    const fullName = this.userInfo?.fullName ?? '';

    const hasNumber = /\d/.test(fullName);

    if (!hasNumber && fullName.trim() !== '') {
      return fullName;
    }

    return this.personalInfo?.ar_FullName ?? '';
  }


  sendOtpEmail(){

    var body={
      "newEmail": this.email
    }

    var request= this.apiService.post('auth/ChangeEmailSendOtp',body);

    request.subscribe(response=>{
      if(response.statusCode==200){
        this.token=response.data.changeEmailToken;

        this.showChageEmailDialog=false;
        this.showOtpDialog=true;

      }
    });

  }

  sendOtpPhone(){

    var body={
      "newPhoneNumber": this.phone?.e164Number
    }

    var request= this.apiService.post('auth/ChangePhoneNumberSendOtp',body);

    request.subscribe(response=>{
      if(response.statusCode==200){
        this.token=response.data.changePhoneNumberToken;
        this.showChagePhoneDialog=false;
        this.showOtpDialog=true;  
      }
    });

  }


  sendOtp(){


    if(this.email!=undefined && this.email!=''){

      let body={
        "otp": this.otp,
        "email": this.email,
        "tokenChangeEmail": this.token
      };
  
      var request=this.apiService.post('auth/ChangeEmail',body);

      request.subscribe(response=>{

        if(response.statusCode==200){

          this.showOtpDialog=false;
          this.email=undefined;
          this.phone=undefined;
          this.otp=undefined;
          this.token=undefined;

          this.sweetAlertservice.ShowAlertThenRedirect('success','تم التغيير بنجاح',this.mainPath+'/Profile');

        }else if(response.statusCode==400){

          this.sweetAlertservice.ShowAlert('error',response.message);
        }

      });

    }
    else if(this.phone){

      let body={
        "otp": this.otp,
        "phoneNumber": this.phone?.e164Number,
        "tokenChangePhoneNumber": this.token
      };
  
      var request=this.apiService.post('auth/ChangePhoneNumber',body);

      request.subscribe(response=>{

        if(response.statusCode==200){

          this.showOtpDialog=false;
          this.email=undefined;
          this.phone=undefined;
          this.otp=undefined;
          this.token=undefined;

          this.sweetAlertservice.ShowAlertThenRedirect('success','تم التغيير بنجاح',this.mainPath+'/Profile');


        }else if(response.statusCode==400){

          this.sweetAlertservice.ShowAlert('error',response.message);

        }

      });
    }

  }


}
